import React, {useEffect, useState} from "react";
import { Link } from "react-router-dom";
import {Button, Card, Badge, Pagination, Nav, Alert, Tab, Modal} from "react-bootstrap"
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import {IconButton} from "@material-ui/core";
import clsx from "clsx";
import ProgressionButtons from "../../SubCompounents/ProgressionButtons";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import PerfectScrollbar from "react-perfect-scrollbar";
import {highlightSelection} from "../../Globals/HighLighter";
import { TagPicker } from 'rsuite';
import '../../css/TagsPicker.css'


import {
    AddCommentOutlined,
    CheckOutlined,
    Close, EditOutlined,
    FavoriteBorderOutlined,
    FlagOutlined
} from "@material-ui/icons";
import './Exams.css'
import '../../css/siamois.css'
import {useMediaQuery} from "@material-ui/core";
import {useParams} from "react-router-dom";

import PieChart from "../../SubCompounents/PieChart";
import {RecaputalitifRevision} from "./Recapitulatifs";
import Select from "react-select";
import {Form} from 'react-bootstrap'
import {Dialog , DialogTitle , DialogContentText , DialogActions , DialogContent} from "@material-ui/core";
import Slide from '@material-ui/core/Slide';
import CreatableSelect from 'react-select/creatable';
import avatar from "../../images/Siamois/images/Me.jpg";
import {useMemo} from "react";
import {useRef} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    clearRevisionInternalTimer,
    clickQuestionOption,
    clickSubQuestionOption,
    deleteChoosenOptionsRevision,
    fetchAddComment,
    fetchAddQuestionToPlaylist,
    fetchAddQuestionToPlaylists,
    fetchFlagQuestion, fetchGetComment,
    fetchGetRevision,
    fetchGetUserPlayLists,
    fetchPostRevisionAnswer,
    goNextQuestionRevision,
    goNextSubQuestion,
    goNthQuestionRevision,
    goNthSubQuestion,
    goPreviousQuestionRevision,
    incrementRevisionTimer,
    setIntervalRevisionTimer,
    setVerifAnswerModeStatus,
    togglePauseModal,
    verifyUserAnswer
} from "../../redux/actions/actions";
import {setHowmanyPaginationButtonsToClick} from "../../redux/actions/actionsRecapitulatifs";
import {
    PropositionsLoader,
    QuestionNameLoader,
    QuestionTextLoader,
    QuestionTypeLoader
} from "./SkeletonLoaders/Loaders";
import swal from "sweetalert";
import reqErrorsReducer from "../../redux/reducers/interStatsMangement/reqErrorsReducer";
import {BottomSheet  } from "react-spring-bottom-sheet";
import './Explanation.css';

const Explanation =({ content , isCorrect , toggleAddCommentDropDownStatus , isOpen , onDismiss , onOpen  })=>{
    let revision= useSelector(state=>state.revision);
    const lg = useMediaQuery('(min-width:992px)');
    const focusRef = useRef();
    const sheetRef = useRef();
    return (
        <React.Fragment>
                {
                    revision.verifAnswerMode ? (
                        <div
                            className={ clsx("pr-4 pl-4 pb-4 pt-2 mt-1 mt-lg-1 explanation" , {correctExplanation : isCorrect , wrongExplanation : !isCorrect}) }
                        >
                            <div className="d-flex justify-content-between align-items-center">
                                <strong> {isCorrect ?  'Correcte !' : 'Fausse !'}</strong>
                                <IconButton onClick={toggleAddCommentDropDownStatus} aria-label="addComment">
                                    <AddCommentOutlined  style={{color : 'white'}}/>
                                </IconButton>
                            </div>
                            <div className="d-flex justify-content-center">
                                <Button onClick={()=>{ onOpen()}} className="light" style={ lg ? {fontSize : '1rem'} : {fontSize : '0.7rem'}} variant="info">Afficher l'explication</Button>
                            </div>
                        </div>
                    ) : null
                }
            <BottomSheet
                open={isOpen}
                onDismiss={()=>onDismiss()}
                header={<div  className="sheetHeader">Explication</div>}
                // sibling={<div className="sheetFooter">YOUR MAIN FOOTER</div>}
                ref={sheetRef}
                initialFocusRef={focusRef}
                defaultSnap={({ maxHeight }) => maxHeight / 2}
                snapPoints={({ maxHeight }) => [
                    maxHeight - maxHeight / 10,
                    maxHeight / 4,
                    maxHeight * 0.6,
                ]}
                footer={
                    <div className="d-flex justify-content-center">
                        <Button onClick={()=>{toggleAddCommentDropDownStatus(); onDismiss()} }  className="light" variant="info" >
                            Ajouter une note personelle
                        </Button>
                    </div>

                }
            >
            <div style={{visibility : 'hidden'}} > p</div>
                    <div className="sheetBody">
                        {content}
                    </div>
            </BottomSheet>
        </React.Fragment>

    )
    // return (
    //     <div
    //         className={ clsx("pr-4 pl-4 pb-4 pt-2 mt-1 mt-lg-1 explanation" , {correctExplanation : isCorrect , wrongExplanation : !isCorrect}) }
    //     >
    //         <div className="d-flex justify-content-between align-items-center">
    //             <strong> {isCorrect ?  'Correcte !' : 'Fausse !'}</strong>
    //             <IconButton onClick={toggleAddCommentDropDownStatus} aria-label="addComment">
    //                 <AddCommentOutlined  style={{color : 'white'}}/>
    //             </IconButton>
    //         </div>
    //         <div id="explanationContent">{content}</div>
    //     </div>
    // )

};

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

// le compteur
const Timer=({lg , hours , minutes , seconds})=>{

    return(
        <div className="font-weight-bold" style={ lg ? {color : '#fff' , fontSize : '1.2rem' , padding: '1.5rem 1.875rem'}: {color : '#fff' , fontSize: '0.8rem'}}>
            {hours < 10 ? '0'+hours : hours}:{minutes < 10 ? '0'+minutes : minutes}:{seconds < 10 ? '0'+seconds : seconds}
            {/*{Math.floor(secondsElapsed/3600) < 10 ? '0'+Math.floor(secondsElapsed/3600) : Math.floor(secondsElapsed/3600) }:{Math.floor(secondsElapsed/60)< 10 ? '0'+Math.floor(secondsElapsed/60) : Math.floor(secondsElapsed/60)  }:{secondsElapsed%60 < 10 ? '0'+secondsElapsed%60 : secondsElapsed%60}*/}
        </div>
    )
}

// QCM/CCQCM/QCU
const ExamBadge =(props)=>{
    return(
        <span className="p-3 mr-3 rounded-circle bg-white font-weight-bold d-flex justify-content-center align-items-center" style={ props.lg ?{color : 'var(--info)', height : '50px' , width : '50px'} : {color : 'var(--info)', height : '40px' , width : '40px'} }>
                                 <span>{props.children}</span>
            </span>
    )
};

//THE BLUE PARt IN THE QUESTION
const ExamCardHeader=({questionType , actualQuestionIndex , quizLength, lg , setHighLightActivated , setAddToPlaylistModalStatus , setFlagQuestionModalOpenStatus , isHighlighted})=>{
    const revision = useSelector(state=>state.revision);
    const dispatch=useDispatch();

    return (
        <div className="d-lg-flex w-100">
            <div className="card-header bg-info flex-column flex-lg-row p-0 p-lg-2" style={lg ?{borderTopRightRadius : 0 , width : '85%'  } : {}}>
                <div className="d-none d-lg-flex align-items-center">
                    { revision.loading ? <QuestionTypeLoader/> : <ExamBadge lg={lg}> <span id="ccqcmBadge"> { questionType }</span> </ExamBadge> }
                    { revision.loading ? <QuestionNameLoader/> : <div id="questionInfo">ECH normal et pathologique - Q {actualQuestionIndex}/{quizLength}</div>}
                </div>
                <div className="d-lg-flex w-md-sm-100">
                    <div id="questionIconsContainer" className="d-flex align-items-center">
                        <div className="d-lg-none">{revision.loading ? <QuestionTypeLoader/> : <ExamBadge lg={lg} > <span id="ccqcmBadge">{revision.actualQuestion.type}</span> </ExamBadge> } </div>
                        <IconButton onClick={()=>{setHighLightActivated(oldState=>!oldState)}} style={!lg ? { padding : '8px'} : {}}  className="mr-lg-2 light btn-primary questionIcons" aria-label="edit">
                            <EditOutlinedIcon style={{  fontSize : lg ? 25 : 18 }}  />
                        </IconButton>
                        <IconButton onClick={()=>setAddToPlaylistModalStatus(true)} style={!lg ? { padding : '8px'} : {}}  className="mr-lg-2 light btn-primary questionIcons" aria-label="favourite">
                            <FavoriteBorderOutlined style={{  fontSize : lg ? 25 : 18 }}  />
                        </IconButton>
                        <IconButton style={!lg ? { padding : '8px'} : {}}  className="mr-lg-2 light btn-primary questionIcons" aria-label="send a report">
                            <FlagOutlined onClick={()=>setFlagQuestionModalOpenStatus(true)}  style={{  fontSize : lg ? 25 : 18 }}  />
                        </IconButton>
                    </div>
                </div>
            </div>
            <div id={revision.data &&   revision.actualQuestionsTimer[revision.actualQuestionIndex] > revision.actualQuestion.estimated_time ?  "timerContainerRetard" : "timerContainer"} className="white d-lg-flex align-items-lg-center justify-content-lg-center" style={lg ? {width : '15%' , borderTopRightRadius : 'calc(0.75rem - 1px)' , marginBottom: '1px'} : {}}>
                <Timer lg={lg} hours={revision.loading ? 0 : Math.floor(revision.actualQuestionsTimer[revision.actualQuestionIndex] /3600)} minutes={revision.loading ? 0 : Math.floor(revision.actualQuestionsTimer[revision.actualQuestionIndex] /60)} seconds={revision.loading ? 0 :  revision.actualQuestionsTimer[revision.actualQuestionIndex] %60} />
            </div>
        </div>

    )
}

const Proposition=({choosed , correct , text , letter , id , verifAnswer , ccqcmMode })=>{
    const dispatch=useDispatch();
    const revision= useSelector(state=>state.revision);
    return(
        <tr onClick={ !verifAnswer  ? !ccqcmMode ?  ()=>{ dispatch(clickQuestionOption(id , revision.actualQuestion.type)) } : ()=>{ dispatch(clickSubQuestionOption(id , revision.actualSubQuestion.type , revision.actualSubQuestion.id)) } : null}>
            <td className={ clsx("pt-lg-3 pb-lg-3 mt-lg-2 pb-1 pt-1 propositionTD d-flex align-items-center mr-3 ml-3 mt-2 mb-2 mr-lg-0 ml-lg-0" , { correctProp : choosed && correct && verifAnswer , wrongProp : choosed && !correct && verifAnswer , choosedProp : choosed && !verifAnswer }) }>
                <Pagination
                    size="sm"
                    className={`mt-4 pagination-gutter pagination-info pagination-circle no-bg`}
                >
                    <Pagination.Item className={clsx( { correctPropLetter : correct && verifAnswer , wrongPropLetter : !correct && verifAnswer, choosedPropLetter : choosed && !verifAnswer })}  active={false}>
                        {letter}
                    </Pagination.Item>
                </Pagination>
                <div className={ clsx("propositionText w-100")} >
                    {text}
                </div>
            </td>
        </tr>
    )
};

function  Propositions({propositions , verifAnswer , ccqcmMode}){
    const revision = useSelector(state=>state.revision);
    if(!ccqcmMode){
        return(
            <div id="propositionsContainer" className="table-responsive">
                <table id="propositions" className="table shadow-hover">
                    <tbody>
                    {propositions.map((proposition , index)=><Proposition id={proposition.id} letter={String.fromCharCode(65 + index)} text={proposition.text} key={proposition.id} choosed={revision.actualChoosenOptions.includes(proposition.id)} correct={proposition.is_correct} verifAnswer={verifAnswer} />) }
                    </tbody>
                </table>
            </div>

        )
    }else{
        const actualQ = revision.actualAllSubChoosenOptions.filter(choosenOptions=>choosenOptions.subquestionId === revision.actualSubQuestion.id)[0];
        return(
            <div id="propositionsContainer" className="table-responsive">
                <table id="propositions" className="table shadow-hover">
                    <tbody>
                    {propositions?.map((proposition , index)=>{
                        return (
                            <Proposition ccqcmMode id={proposition.id} letter={String.fromCharCode(65 + index)} text={proposition.text} key={proposition.id} choosed={actualQ.actualChoosenOptions.includes(proposition.id)} correct={proposition.is_correct} verifAnswer={verifAnswer} />
                        )
                    }) }
                    </tbody>
                </table>
            </div>
        )
    }

}

const CCQCMContainer=(props)=>{
    const revision=useSelector(state=>state.revision);
    const dispatch = useDispatch();
    const tabData=revision.actualQuestion.subquestions.map((subQuestion , index)=>{
        return {
            name : index
        }
    })
    return(
        <Tab.Container
            defaultActiveKey={0}
            activeKey={revision.actualSubQuestionIndex}
        >
            <Nav id="ccqcmNavTabs" as="ul" className="nav-pills pt-2 pb-2 light">
                {/*<div className="deznav" style={{position : 'relative' , overflow : 'hidden' }} >*/}
                <PerfectScrollbar>
                    {tabData.map(
                        (data, index) =>
                            (
                                <Nav.Item as="li" key={index}>
                                    <Nav.Link
                                        eventKey={index}
                                        onClick={()=>dispatch(goNthSubQuestion(index))}
                                    >
                                        Tab{" "}
                                        {data.name}
                                    </Nav.Link>
                                </Nav.Item>
                            )
                    )}
                </PerfectScrollbar>
                {/*</div>*/}
            </Nav>
            <Tab.Content className="">
                {tabData.map(
                    (data, index) =>
                        (
                            <Tab.Pane
                                eventKey={index}
                                key={index}
                            >
                                {props.children}

                            </Tab.Pane>
                        )
                )}
            </Tab.Content>
        </Tab.Container>
    )
}


const ExamCardBody=({isHighLightActivated , toggleAddCommentDropDownStatus ,explanationPanelOpened , setExplanationPanelOpened })=>{
    const revision = useSelector(state=>state.revision);
    const lg = useMediaQuery('(min-width:992px)');
    const Tags=({data})=>{
        return(
            <div className="pl-lg-5 pl-4 mb-lg-3 mb-2 d-flex justify-content-center justify-content-lg-start flex-wrap">
                {data.map(tag=><Badge key={tag.id} className="mr-2 mb-1" style={{color : '#fff'}} variant="success">{tag.name}</Badge>)}
            </div>
        )
    }
    return (
        <div  id="cardScrollPart" style={ lg ? {maxHeight : '60vh' , overflowY : 'auto' } : {maxHeight : '65vh' , overflowY : 'auto'} } className="card-body p-0">
            { revision.loading ? <QuestionTextLoader/> :
                <React.Fragment>
                    <div id="questionBody"
                         onMouseUp={()=>{if(isHighLightActivated){
                             const s= window.getSelection().toString();
                             if(!s.length){
                                 return null
                             }
                             highlightSelection();
                         }else{return null} }}
                         className={clsx("pl-lg-5 pt-lg-3 pr-lg-5  pl-4 pr-4 pt-2 pb-2" , { toHighlight : isHighLightActivated})}  >
                        {revision.actualQuestion.text}
                    </div>
                    <Tags data={revision.actualQuestion ? revision.actualQuestion.tags : []}/>
                </React.Fragment>

            }
            <div className="mr-lg-4 ml-lg-4" style={ lg ?{borderTop : '1px solid #eee'} : {borderTop : '1px solid #eee' , display : 'flex' , flexDirection : 'column'}}>
                {  revision.loading ? <PropositionsLoader/> : revision.actualQuestion.type !== 'CCQCM' ?
                    <Propositions verifAnswer={revision.verifAnswerMode}  propositions={revision.actualQuestion.options}/> :
                    <CCQCMContainer>
                        <div className="ccqcmQuestionText pt-2 pt-lg-3"> {revision.actualSubQuestionIndex+1}. {revision.actualSubQuestion.text}</div>
                        <Propositions ccqcmMode verifAnswer={revision.verifAnswerMode}  propositions={revision.actualSubQuestion.options}/> :
                    </CCQCMContainer>

                }
            </div>
            {  revision.verifAnswerMode  ?
                revision.actualQuestion.type !=='CCQCM' ?  <Explanation onOpen={()=>setExplanationPanelOpened(true)} onDismiss={()=>setExplanationPanelOpened(false)} isOpen={revision.verifAnswerMode && explanationPanelOpened} toggleAddCommentDropDownStatus={toggleAddCommentDropDownStatus} content={revision.actualQuestion.explanation} isCorrect={revision?.userScore.filter(question=>question.questionIndex===revision.actualQuestionIndex).length &&  revision?.userScore.filter(question=>question.questionIndex===revision.actualQuestionIndex)[0].correct } /> :
                    <Explanation onOpen={()=>setExplanationPanelOpened(true)}  onDismiss={()=>setExplanationPanelOpened(false)} isOpen={revision.verifAnswerMode && explanationPanelOpened} ccqcmMode toggleAddCommentDropDownStatus={toggleAddCommentDropDownStatus} content={revision.actualSubQuestion.explanation} isCorrect={revision?.userSubScore.filter(question=>question.questionId===revision.actualSubQuestion.id).length &&  revision?.userSubScore.filter(question=>question.questionId===revision.actualSubQuestion.id)[0].correct } />
                    : null
            }
        </div>
    )
}



const Revision = () => {
    const sm = useMediaQuery('(min-width:576px)');
    const md = useMediaQuery('(min-width:768px)');
    const lg = useMediaQuery('(min-width:992px)');
    const xl= useMediaQuery('(min-width:1200px)');
    let { quizId } = useParams();
    const ps = new PerfectScrollbar('#ccqcmNavTabs');
    const pauseModal=useSelector(state=>state.pauseModal);
    const dispatch= useDispatch();
    const [addToPlayListModalOpen , setAddToPlaylistModalStatus] = useState(false);
    const [flagQuestionModalOpen, setFlagQuestionModalOpenStatus] = React.useState(false);
    const [addCommentDropDownStatus , setAddCommentDropDownStatus] = React.useState(false);
    const [userComment , setUserComment]=React.useState(null);
    const [startTimeTimer , setStartTimeTimer]=React.useState(null);
    const [secondsElapsed , setSecondsElapsed]=React.useState(0);
    const [isLoading , setIsLoadingStatus]=useState(true);
    const [flagQuestionCauses  , setFlagQuestionCauses]=useState(['La question est incorrecte sur le plan des faits' , 'La réponse de cette question est erronée' , "L'explication de cette question est inconvenable"]);
    const [selectedFlagQuestionCause , setSelctedFlagQuestionCause]=useState(null);
    const flagQuestionDetailRef=useRef(null);
    const [isHighLightActivated , setHighLightActivated]=useState(false);
    // how many progression buttons are shown
    // how many progression buttons to show for each click
    const [NbProgressionButtonsperClick , setNbProgressionButtonsperClick]=useState(5);
    const [playlistNamesToCreateArr , setPlaylistNamesToCreateArr]= useState([]);
    // The bottom panel i will show during the explanation
    const [explanationPanelOpened , setExplanationPanelOpened] = useState(false);
    // the comments array
    const comments = useSelector(state => state.comments);

    const onDismissExplanationPanel =()=>{
        setExplanationPanelOpened(false);
    }
    // const [playListOptions , setPlayListOptions] = useState(
    //     [
    //         { value: "playlist 1", label: "playlist 1" },
    //         { value: "playlist 2", label: "playlist 2" },
    //         { value: "playlist 3", label: "playlist 3" },
    //     ]
    // );
    //
    const [selectedPlaylists , setSelectedPlaylists]=useState([]);
    const reqErrors=useSelector(state=>state.reqErrors);
    const revision=useSelector(state=>state.revision);
    const toggleAddCommentDropDownStatus= React.useCallback(()=>{
        setAddCommentDropDownStatus(!addCommentDropDownStatus);
    }, [addCommentDropDownStatus]);
    const user = useSelector(state=>state.user);
    useEffect(()=>{
        dispatch(fetchGetRevision(quizId));
        dispatch(fetchGetUserPlayLists());
    },[]);
    // To detect when i got my data (when revision.loading=true)
    useEffect(()=>{
        console.log('revision = ', revision);
        if(!revision.loading && isLoading){
            setIsLoadingStatus(false);
        }
    },[revision]);
    // if the comment Modal is opened we will begin teh process of getting the comment of this question
    useEffect(()=>{
        if(addCommentDropDownStatus){
            dispatch(fetchGetComment(revision.actualQuestion.id))
                .catch(()=>{
                    swal(
                        comments.error,
                        "",
                        "error"
                    )
                })
        }
    }, [addCommentDropDownStatus])


    useEffect(()=>{
        console.log('ADD EVENT LISTENER !')
            window.addEventListener("keydown", keyPressed);
        return () => {
            window.removeEventListener("keydown", keyPressed);
        };
    },[revision , flagQuestionModalOpen , addToPlayListModalOpen])

    useEffect(()=>{
        if(isLoading===false){
            const timerInterval =setInterval(()=>{
                dispatch(incrementRevisionTimer(revision.actualQuestionIndex))
            },1000);
            dispatch(setIntervalRevisionTimer(timerInterval));
        }
    },[isLoading])

    useEffect(()=>{
        if(!revision.verifAnswerMode && !revision.loading){
            console.log('verif Answer is false !');
            const timerInterval =setInterval(()=>{
                dispatch(incrementRevisionTimer(revision.actualQuestionIndex))
            },1000);
            dispatch(setIntervalRevisionTimer(timerInterval));
            // setIntervalTimer(timerInterval);
        }
    }, [revision.verifAnswerMode]);

    useEffect(()=>{
        if(!revision.loading && !pauseModal.isOpen){
            console.log('pause modal is closed !');
            const timerInterval =setInterval(()=>{
                dispatch(incrementRevisionTimer(revision.actualQuestionIndex))
            },1000);
            dispatch(setIntervalRevisionTimer(timerInterval));
            // setIntervalTimer(timerInterval);
        }
    }, [pauseModal.isOpen]);

    useEffect(()=>{
        if(pauseModal.isOpen){
            console.log('pause modal is open!');
            dispatch(clearRevisionInternalTimer());
            // clearInterval(intervalTimer)
        }
    }, [pauseModal.isOpen]);



    const handleChangePlayList = (newValue, actionMeta) => {
        // console.group('Value Changed');
        console.log('TAB INDEX =',document.querySelector('#myModal').getAttributeNames());
        console.log(newValue);
        console.log(`action: ${actionMeta.action}`);
        // console.groupEnd();
    };
    const handleInputChangePlayList = (inputValue , actionMeta) => {
        console.log('TAB INDEX =',document.querySelector('#myModal').getAttribute('tabindex'));
        // console.group('Input Changed');
        console.log(inputValue);
        console.log(`action: ${actionMeta.action}`);
        // console.groupEnd();
    };



    const AddCommentDropDown=({isOpen})=>{
        return null;

    }


    const submitFlagQuestion=()=>{
        const toPost ={
            question_id : revision.actualQuestion.id,
            reason : selectedFlagQuestionCause,
            comment : flagQuestionDetailRef.current.value
        }
        console.log('POST submit flag Question =',toPost);
        dispatch(fetchFlagQuestion(toPost))
            .then(()=>{
                swal(
                    "Your report was sent successfuly !",
                    "",
                    "success"
                )
            })
            .catch(()=>{
                swal(
                    reqErrors.flagQuestion.error,
                    "",
                    "error"
                )
            })
        setFlagQuestionModalOpenStatus(false);
        setSelctedFlagQuestionCause(null);
        flagQuestionDetailRef.current.value='';
    }

    const cancelFlagQuestion=()=>{
        setFlagQuestionModalOpenStatus(false);
        setSelctedFlagQuestionCause(null);
        flagQuestionDetailRef.current.value='';
    }

    const verifAnswerClicked=()=>{
        dispatch(setVerifAnswerModeStatus(true));
        dispatch(clearRevisionInternalTimer());
        dispatch(verifyUserAnswer());
        setTimeout(()=>{
            var myDiv = document.getElementById("cardScrollPart");
            myDiv.scrollTop = myDiv.scrollHeight;
        },100);
        let toPost={};
        console.log('POST save ANSWER =', toPost);

        if(revision.actualQuestion.type !== 'CCQCM'){
            toPost={
                quiz_id : Number(quizId),
                question_id : revision.actualQuestion.id,
                time : revision.actualQuestionsTimer[revision.actualQuestionIndex],
                choices : revision.actualChoosenOptions
            }
        }else{
            toPost = {
                quiz_id : Number(quizId),
                question_id : revision.actualQuestion.id,
                answers : revision.actualAllSubChoosenOptions.map((subQ , index)=>{
                    return {
                        question_id : subQ.subQuestionId,
                        choices : subQ.actualChoosenoptions,
                        time : revision.actualQuestionsTimer[revision.actualQuestionIndex]
                    }
                })
            }
        }
        dispatch(fetchPostRevisionAnswer(toPost , revision.actualQuestion.type));

    }
    const nextQuestionClicked=()=>{
        let isNextCorrect=revision.userScore.filter(score=>score.questionIndex===revision.actualQuestionIndex+1).length && revision.userScore.filter(score=>score.questionIndex===revision.actualQuestionIndex+1)[0].correct;
        let isNextWrong= revision.userScore.filter(score=>score.questionIndex===revision.actualQuestionIndex+1).length && !revision.userScore.filter(score=>score.questionIndex===revision.actualQuestionIndex+1)[0].correct;
        if(!isNextWrong && !isNextCorrect){
            dispatch(setVerifAnswerModeStatus(false));
        }else{
            dispatch(setVerifAnswerModeStatus(true));
        }
        if(revision.actualQuestionIndex+1 === revision.howmanyPaginationButtonsToClick && revision.howmanyPaginationButtonsToClick < revision.data.questions_count){
            dispatch(setHowmanyPaginationButtonsToClick(oldState=>oldState+NbProgressionButtonsperClick));
        }
        dispatch(goNextQuestionRevision());
    }
    const keyPressed=(event)=>{
        // console.log('KEY UP !');
        // console.log('event key =', event.key.toLowerCase());
        // console.log('event code =', event.code);
        // console.log('actual question =', revision.actualQuestion );
        if(!flagQuestionModalOpen && !addToPlayListModalOpen && revision.actualQuestion?.options && !addCommentDropDownStatus){
            let propositionsKeys=[];
            revision.actualQuestion.options.forEach((option , index)=>{
                propositionsKeys.push(String.fromCharCode(97 + index))
            });
            console.log('proposition keys =', propositionsKeys)
            let indexPropositionClicked=propositionsKeys.indexOf(event.key.toLowerCase());
            console.log('INDEX =',indexPropositionClicked)
            if(indexPropositionClicked!==-1) {
                console.log('the option choosed is :', revision.actualQuestion.options[indexPropositionClicked]);
                dispatch(clickQuestionOption(revision.actualQuestion.options[indexPropositionClicked].id , revision.actualQuestion.type))
            }
            if(event.code==="Space"){
                console.log('ANSWER MODE =',revision.verifAnswerMode )
                // Verifier la reponse
                if(!revision.verifAnswerMode){
                    verifAnswerClicked();
                    setTimeout(()=>{
                        var myDiv = document.getElementById("cardScrollPart");
                        myDiv.scrollTop = myDiv.scrollHeight;
                    },10)
                }

            }
            if(event.key.toLowerCase()==="p"){
                dispatch(togglePauseModal())
            }
            if(event.code==='ArrowRight'&& revision.actualQuestionIndex+1!==revision.data.questions.length){
                let isCorrect= revision.userScore.filter(score=>score.questionIndex===revision.actualQuestionIndex+1).length && revision.userScore.filter(score=>score.questionIndex===revision.actualQuestionIndex+1)[0].correct;
                let isWrong =revision.userScore.filter(score=>score.questionIndex===revision.actualQuestionIndex+1).length && !revision.userScore.filter(score=>score.questionIndex===revision.actualQuestionIndex+1)[0].correct;
                dispatch(goNthQuestionRevision(revision.actualQuestionIndex+1));
                if(!isCorrect && !isWrong){
                    dispatch(setVerifAnswerModeStatus(false));
                }else{
                    dispatch(setVerifAnswerModeStatus(true));
                }
                // show more pagination buttons
                if(revision.actualQuestionIndex+1 === revision.howmanyPaginationButtonsToClick && revision.howmanyPaginationButtonsToClick < revision.data.questions_count){
                    dispatch(setHowmanyPaginationButtonsToClick(revision.howmanyPaginationButtonsToClick+revision.NbProgressionButtonsperClick));
                }
            }
            if(event.code==='ArrowLeft' && revision.actualQuestionIndex !==0){
                // dispatch(setVerifAnswerModeStatus(false));
                // dispatch(goPreviousQuestionRevision());
                let isCorrect= revision.userScore.filter(score=>score.questionIndex===revision.actualQuestionIndex-1).length && revision.userScore.filter(score=>score.questionIndex===revision.actualQuestionIndex-1)[0].correct;
                let isWrong =revision.userScore.filter(score=>score.questionIndex===revision.actualQuestionIndex-1).length && !revision.userScore.filter(score=>score.questionIndex===revision.actualQuestionIndex-1)[0].correct;
                dispatch(goNthQuestionRevision(revision.actualQuestionIndex-1));
                if(!isCorrect && !isWrong){
                    dispatch(setVerifAnswerModeStatus(false));
                }else{
                    dispatch(setVerifAnswerModeStatus(true));

                }
            }
            if(event.key.toLowerCase()==='tab'){
                dispatch(goNextSubQuestion());
            }
        }

    }
    const submitAddQuestionToPlaylist=()=>{
        let toPost={
            playlists: selectedPlaylists,
            question_id : revision.actualQuestion.id
        }
        console.log('ADD QUESTION TO PLAYLIST BODY  :',toPost);
        dispatch(fetchAddQuestionToPlaylists(selectedPlaylists , revision.actualQuestion.id ))
            .then(()=>{
                setAddToPlaylistModalStatus(false);
                setSelectedPlaylists([]);
                swal(
                    "The question was added to the playlist successfully !",
                    "",
                    "success"
                )
            })
            .catch(()=>{
                setAddToPlaylistModalStatus(false);
                swal(
                    reqErrors.addQuestionToPlaylist.error,
                    "",
                    "error"
                )
            })

    }
    const textAreaAddComment = useRef();
    const sumbmitAddComment=()=>{
        console.log('the current comment = ', textAreaAddComment.current.value);
        dispatch(fetchAddComment(revision.actualQuestion.id ,textAreaAddComment.current.value ))
            .then(()=>{
                textAreaAddComment.current.value=''
            })
            .catch(()=>{
                swal(
                    reqErrors.addComment.error,
                    "",
                    "error"
                )
            })
    }
    // In the case has 0 questions
    if(!revision.loading && revision.actualQuestion===undefined) return <div style={ lg ?{paddingTop : '7.2rem'} : {paddingTop : '4rem' , minHeight : '100vh'}}>0 QUESTIONS !</div>
    return (
        <div   className={clsx(pauseModal.isOpen && 'blurred' , explanationPanelOpened && 'halfOpacity')} style={ lg ?{paddingTop : '7.2rem'} : {paddingTop : '4rem' , minHeight : '100vh'}}>
            <div className="d-lg-flex mt-lg-4 mt-2">
                <div  className="col-lg-8" >
                    <div  style={!lg ? {minHeight : '70vh' , display : 'flex', flexDirection : 'column'} : {}} className="card">
                        <ExamCardHeader isHighlighted={isHighLightActivated} setHighLightActivated={setHighLightActivated}   secondsElapsed={secondsElapsed} questionType={revision.actualQuestion.type}  actualQuestionIndex={revision.actualQuestionIndex+1} quizLength={revision?.data?.questions?.length} lg={lg} loading={revision.loading} setAddToPlaylistModalStatus={setAddToPlaylistModalStatus} setFlagQuestionModalOpenStatus={setFlagQuestionModalOpenStatus} />
                        <ExamCardBody explanationPanelOpened={explanationPanelOpened} setExplanationPanelOpened={setExplanationPanelOpened} isHighLightActivated={isHighLightActivated} toggleAddCommentDropDownStatus={toggleAddCommentDropDownStatus}/>
                    </div>
                    { revision.loading ? null :                     <div className="d-flex justify-content-between mb-3 mb-lg-1">
                        <Button onClick={!revision.verifAnswerMode ? ()=>{dispatch(deleteChoosenOptionsRevision())} : null } style={ lg ? {fontSize : '1rem'} : {fontSize : '0.7rem'}}  variant="outline-warning">Effacer la reponse</Button>
                        { !revision.verifAnswerMode ? <Button onClick={()=>{ verifAnswerClicked()}} className="light" style={ lg ? {fontSize : '1rem'} : {fontSize : '0.7rem'}} variant="primary">Verifier la reponse</Button> :
                            revision.actualQuestionIndex+1!==revision.data.questions.length ?  <Button onClick={()=>{nextQuestionClicked()}} className="light" style={ lg ? {fontSize : '1rem'} : {fontSize : '0.7rem'}} variant="primary">Suivant</Button> :
                                <Button onClick={()=>{console.log('end !')}} className="light" style={ lg ? {fontSize : '1rem'} : {fontSize : '0.7rem'}} variant="primary">Terminer</Button>
                        }
                    </div> }

                </div>
                {
                    lg ? (
                        <div className="col-lg-4">
                            <RecaputalitifRevision />
                        </div>
                    ) :null
                }

            </div>

            {/*<Modals/>*/}
            {/*ADD PLAYLIST MODAL*/}
            <Modal
                className="fade bd-example-modal-sm"
                size="md"
                show={addToPlayListModalOpen}
                id='myModal'
            >
                <Modal.Header>
                    <Modal.Title>Ajouter à une playlist</Modal.Title>
                    <Button
                        variant=""
                        className="close"
                        onClick={() => setAddToPlaylistModalStatus(false)}
                    >
                        <span>&times;</span>
                    </Button>
                </Modal.Header>
                <Modal.Body className="pt-0 pb-0">

                    <div id="SelectPlaylist" className="d-flex flex-column p-2 pb-3 ">
                        <div className="p-2">Nom de playlist : </div>
                        {/*<select*/}
                        {/*    value={selectedPlaylist}*/}
                        {/*    onChange={(e)=>setSelectedPlaylist(e.target.value)}*/}
                        {/*    className="form-control form-control-lg"*/}
                        {/*>*/}
                        {/*    <option disabled selected value> -- Spécifiez le playlist-- </option>*/}
                        {/*    {user.playlists.data.map(playlist=><option value={playlist.id} key={playlist.id}>{playlist.name}</option>)}*/}
                        {/*</select>*/}
                        <TagPicker
                            creatable
                            data={user.playlists.data}
                            style={{ width: 300 }}
                            // menuStyle={{ width: 300 }}
                            // onCreate={(value, item) => {
                            //     setPlaylistNamesToCreateArr(value);
                            // }}
                            onSelect={(value, item , event) => {
                                console.log(' value = ', value , 'item =', item);
                                setSelectedPlaylists(value);
                            }}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {/*<Button*/}
                    {/*    variant="danger light"*/}
                    {/*    onClick={() => setAddToPlaylistModalStatus(false)}*/}
                    {/*>*/}
                    {/*    Close*/}
                    {/*</Button>*/}
                    <Button variant="primary" disbaled={!selectedPlaylists.length && !playlistNamesToCreateArr.length } onClick={submitAddQuestionToPlaylist}>Confirmer</Button>
                </Modal.Footer>
            </Modal>

            {/*REPORT PROBLEM MODAL*/}

            <Modal
                className="fade"
                show={flagQuestionModalOpen}
                size="lg"
            >
                <Modal.Header>
                    <Modal.Title>Signaler cette question</Modal.Title>
                    <Button
                        variant=""
                        className="close"
                        onClick={() => setFlagQuestionModalOpenStatus(false)}
                    >
                        <span>&times;</span>
                    </Button>
                </Modal.Header>
                <Modal.Body >
                    <Form.Group controlId="exampleForm.ControlSelect1">
                        <Form.Label>Veuillez séléctionner la raison la plus appropriée</Form.Label>
                        <select value={selectedFlagQuestionCause} onChange={(e)=>setSelctedFlagQuestionCause(e.target.value)} className="form-control form-control-lg">
                            <option disabled selected value> -- Spécifiez votre raison -- </option>
                            {flagQuestionCauses.map(cause=><option value={cause} key={cause}>{cause}</option>)}
                        </select>
                    </Form.Group>
                    <Form.Group controlId="exampleForm.ControlTextarea1">
                        <Form.Label>Veuillez écrire des bréves remarques sur cette question</Form.Label>
                        <Form.Control ref={flagQuestionDetailRef} as="textarea" rows={3} />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={cancelFlagQuestion} variant="outline">Fermer</Button>
                    <Button onClick={submitFlagQuestion} variant="primary">Confirmer</Button>
                </Modal.Footer>
            </Modal>

            {/*<AddCommentDropDown isOpen={addCommentDropDownStatus}/>*/}
            {/*Add Comment Modal*/}
            <Modal
                className="fade"
                show={addCommentDropDownStatus}
            >
                <Modal.Body>
                    <PerfectScrollbar
                        id="DZ_W_Notification1"
                        className={` widget-media dz-scroll p-3 height380 ps ps--active-y`}
                    >
                        <ul className="timeline">
                            <li>
                                <div className="mb-1 d-flex justify-content-end mr-1">
                                    <IconButton className="p-0" onClick={()=>setAddCommentDropDownStatus(false)} aria-label="closeDropDownComment">
                                        <Close fontSize="small" style={{color : 'black' }}/>
                                    </IconButton>
                                </div>
                                <div className="timeline-panel align-items-center">
                                    <div className="media mr-2">
                                        <img
                                            alt="image"
                                            width={50}
                                            src={avatar}
                                        />
                                    </div>
                                    <div className="media-body">
                                        {
                                            !comments.data.filter(data=>data.questionId === revision.actualQuestion.id ).length ? (
                                                <Form.Group controlId="exampleForm.ControlTextarea1">
                                                    <Form.Control
                                                        onFocus={()=>{console.log('FOCUS ')}}
                                                        as="textarea" rows={3}
                                                        ref={textAreaAddComment}
                                                        placeholder="Ecrire votre commentaire ici"
                                                    />
                                                </Form.Group>
                                            ): (
                                                <React.Fragment>
                                                    <h6 className="mb-1" style={{fontSize : '0.7rem'}}>
                                                        { comments.data.filter(data=>data.questionId === revision.actualQuestion.id )[0].comment }
                                                    </h6>
                                                    <small className="d-block">
                                                        {comments.data.filter(data=>data.questionId === revision.actualQuestion.id )[0].createdAt}
                                                    </small>
                                                </React.Fragment>
                                            )

                                        }

                                    </div>
                                    <div style={{alignSelf : 'center'}}>
                                        {
                                            comments.data.filter(data=>data.questionId === revision.actualQuestion.id ).length ? (
                                                <IconButton onClick={()=>setAddCommentDropDownStatus(!addCommentDropDownStatus)} aria-label="addComment">
                                                    <EditOutlined fontSize="small" style={{color : 'black' }}/>
                                                </IconButton>
                                            ): (
                                                <IconButton onClick={()=>sumbmitAddComment()} aria-label="addComment">
                                                    <CheckOutlined fontSize="small" style={{color : 'green' }}/>
                                                </IconButton>
                                            )
                                        }

                                    </div>
                                </div>
                            </li>
                        </ul>
                    </PerfectScrollbar>
                </Modal.Body>
            </Modal>



            {/*PAUSE MODAL*/}

            <Modal
                className="fade bd-example-modal-sm"
                show={pauseModal.isOpen}
                id='myModal'
                style={{height : '70vh' , overflowY : 'scroll'}}

            >
                <Modal.Header>
                    <Modal.Title>PAUSE</Modal.Title>
                    <Button
                        variant=""
                        className="close"
                        onClick={() =>{
                            dispatch(togglePauseModal());
                        } }
                    >
                        <span>&times;</span>
                    </Button>
                </Modal.Header>
                <Modal.Footer className="d-flex justify-content-around">
                    <Button
                        variant="danger light"
                        className="pauseButtonsModal"
                    >
                        Enregistrer & quitter
                    </Button>
                    <Button
                        className="pauseButtonsModal"
                        variant="primary"
                        onClick={()=>dispatch(togglePauseModal())}
                    >Reprendre</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default React.memo(Revision);
